import { FormControl, Select, InputLabel, MenuItem } from '@mui/material'
import { useTranslation } from '@theme/base/contexts/TranslationContext'
import { SHOW_ALL_QUERY_PARAM_VALUE } from '@constants'
import { useFormikContext, FormikValues } from 'formik'
import { ILabelValueString } from '@schemas/generic'

interface SelectFilterFormikProps {
  paramName: string
  labelTranslationKey: string
  options: ILabelValueString[]
  allOptionGender?: 'masculine' | 'feminine' | undefined
  size?: "small" | "medium",
  showAllOption?: boolean,
  onChange?: (value: string) => void
}

const SelectFilterFormik = ({ paramName, labelTranslationKey, options, allOptionGender, size = "small", showAllOption= true, onChange }: SelectFilterFormikProps) => {
  const { getTranslation } = useTranslation()
  const { setFieldValue, values, handleSubmit } = useFormikContext<FormikValues>()

  const label = getTranslation(labelTranslationKey)
  const allOptionTranslationKey = allOptionGender == 'feminine' ? 'common.filters.all.feminine' : 'common.filters.all.masculine'

  const handleChange = (value: string) => {
    setFieldValue(paramName, value === SHOW_ALL_QUERY_PARAM_VALUE ? undefined : value)
    setFieldValue('page', 1)
    onChange?.(value)
    handleSubmit()
  }

  return (
    <FormControl fullWidth size={size}>
      <InputLabel id={`select-label-${paramName}`}>{label}</InputLabel>
      <Select
        labelId={`select-label-${paramName}`}
        id={`select-id-${paramName}`}
        label={label}
        value={values[paramName] ?? ''}
        onChange={(e) => handleChange(e.target.value?.toString())}
      >
        {showAllOption && <MenuItem value={SHOW_ALL_QUERY_PARAM_VALUE}>{getTranslation(allOptionTranslationKey)}</MenuItem>}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectFilterFormik
